import React from "react";
import type { SectionComponentProps } from "../../registry.js";

interface CtaBannerProps {
  headline?: string;
  subheadline?: string;
  ctaLabel?: string;
  ctaTarget?: string;
  secondaryLabel?: string;
  secondaryTarget?: string;
}

export function CtaBanner({ props }: SectionComponentProps) {
  const {
    headline = "An evening to remember",
    subheadline = "Reserve your table and let us take care of the rest. Intimate dinners, celebrations, and everything in between.",
    ctaLabel = "Reserve a Table",
    ctaTarget = "#reservations",
    secondaryLabel = "View Menu",
    secondaryTarget = "/menu",
  } = props as CtaBannerProps;

  return (
    <section
      className="relative py-24 px-6 bg-primary text-primary-foreground overflow-hidden"
      id="cta"
    >
      {/* Decorative background circles */}
      <div className="pointer-events-none absolute -top-24 -right-24 w-96 h-96 rounded-full bg-white/5" />
      <div className="pointer-events-none absolute -bottom-16 -left-16 w-64 h-64 rounded-full bg-white/5" />

      <div className="relative max-w-2xl mx-auto text-center space-y-6">
        <h2 className="text-3xl md:text-5xl font-bold leading-tight">{headline}</h2>
        {subheadline && (
          <p className="text-primary-foreground/75 text-lg leading-relaxed">{subheadline}</p>
        )}
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
          <a
            href={ctaTarget}
            className="inline-flex items-center justify-center rounded-[var(--radius)] bg-background text-foreground px-8 py-3 text-sm font-semibold shadow-sm hover:opacity-90 transition-opacity"
          >
            {ctaLabel}
          </a>
          {secondaryLabel && (
            <a
              href={secondaryTarget}
              className="inline-flex items-center justify-center rounded-[var(--radius)] border border-primary-foreground/30 px-8 py-3 text-sm font-semibold hover:bg-white/10 transition-colors"
            >
              {secondaryLabel}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
